module.exports = __webpack_public_path__ + "img/logo-tutu-digital.jpg";